import { Colors } from 'styles';
import styled from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';

const SectionBox = styled.section<{
  $css?: FlattenSimpleInterpolation;
}>`
  min-height: 44px;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${Colors.gray9};
  width: 100%;
  ${({ $css }) => $css || ''};
`;

type RightDrawerSectionProps = {
  headerDataTestId?: string;
  className?: string;
  children: React.ReactNode;
  css?: FlattenSimpleInterpolation;
};

export const RightDrawerSection = ({
  children,
  className,
  css,
}: RightDrawerSectionProps): React.ReactElement => {
  return (
    <SectionBox className={className} $css={css}>
      {children}
    </SectionBox>
  );
};
